import React, { useEffect, useState } from "react";
import SelectField from "../components/MySelect";
import { useGetPickupQuery } from "../store/api/recipientApi";
import { useSetPickupPointMutation } from "../store/api/buyForMeApi";
import Button from "../components/Button";

const ContactsPage = () => {
  const [form, setForm] = useState({
    selectedPickup: 0,
  });

  const [setPickupPoint] = useSetPickupPointMutation();

  const { data: pickup = { pickup_list: [] }, refetch } = useGetPickupQuery();

  useEffect(() => {
    if (Array.isArray(pickup.prefer_pickup) && pickup.prefer_pickup.length > 0) {
      setForm({
        selectedPickup: pickup.prefer_pickup[0].prefer_pickup,
      });
    }
  }, [pickup]);
  return (
    <div className="personal-info-form">
      <div className="form-title">Контакты и выбор пунктов выдачи</div>
      <div className="" style={{ maxWidth: 480 }}>
      </div>
      <div className="recipient-row" style={{ paddingTop: "45px" }}>
        <span className="recipient-label">Телефон с WhatsApp:</span>{" "}
        <span className="recipient-value">+996 227 080 008</span>
      </div>
      <div className="recipient-row">
        <span className="recipient-label">Email:</span>{" "}
        <span className="recipient-value">info@onza.kg</span>
      </div>
      <SelectField
        label="Предпочитаемый пункт выдачи"
        value={form.selectedPickup}
        onChange={(e) => {
          setForm({
            ...form,
            selectedPickup: e.target.value,
          });
        }}
        placeholder="Выберите пункт"
        options={[...(pickup?.pickup_list ?? [])]}
      />
      {Array.isArray(pickup.prefer_pickup) &&
        pickup.prefer_pickup.length > 0 &&
        pickup.prefer_pickup[0].prefer_pickup != form.selectedPickup ? (
        <Button
          onClick={async () => {
            const { data } = await setPickupPoint({
              pickup: form.selectedPickup,
            });
            alert(data?.message);
            refetch();
          }}
        >
          Сохранить
        </Button>
      ) : ""}

      <div className="office-section">
        <div className="office-card">
          <h3 className="office-title">Бишкек — Головной офис</h3>
          <p className="office-address">
            мкр. 7, ул. Безымянная 4/5<br />
            <span>
              Ориентир — Ортоcайский рынок, ярусная парковка, магазин «Океан»
            </span>
          </p>
          <ul className="office-time">
            <li>Пон.–Пт.: 10:00 – 20:00 (без обеда)</li>
            <li>Сб.: 11:00 – 14:00</li>
            <li>Вс.: выходной</li>
          </ul>
        </div>

        <div className="office-card">
          <h3 className="office-title">Бишкек — Пункты выдачи</h3>

          <div className="office-sub">
            <strong>Офис Pony Express</strong>
            <p>пр. Чуй 128</p>
            <ul className="office-time">
              <li>Пон.–Пт.: 9:00 – 18:00 (обед 12:00–13:00)</li>
              <li>Сб., Вс.: выходной</li>
            </ul>
          </div>

          <div className="office-sub">
            <strong>Офис Pony Express</strong>
            <p>ул. Медерова 181</p>
            <ul className="office-time">
              <li>Пон.–Пт.: 9:00 – 18:00</li>
              <li>Сб.: 10:00 – 18:00</li>
              <li>Вс.: выходной</li>
            </ul>
          </div>
        </div>

        <div className="office-card">
          <h3 className="office-title">Ош</h3>
          <div className="office-sub">
            <strong>Офис Pony Express</strong>
            <p>ул. Курманжан Датка 121B</p>
            <ul className="office-time">
              <li>Пон.–Пт.: 9:00 – 18:00</li>
              <li>Сб., Вс.: выходной</li>
            </ul>
          </div>
        </div>
      </div>

    </div>
  );
};

export default ContactsPage;
